var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8133 8.81225H18.1066C19.5293 8.81225 20.6933 9.94526 20.6933 11.33V23.919C20.6933 25.3038 19.5293 26.4368 18.1066 26.4368H2.58666C1.164 26.4368 0 25.3038 0 23.919V11.33C0 9.94526 1.164 8.81225 2.58666 8.81225H3.87999V6.29447C3.87999 2.81992 6.77706 0 10.3466 0C13.9162 0 16.8133 2.81992 16.8133 6.29447V8.81225ZM6.4672 6.29461V8.8124H14.2272V6.29461C14.2272 4.20485 12.4941 2.51793 10.3472 2.51793C8.20026 2.51793 6.4672 4.20485 6.4672 6.29461Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.003a348608f7a8ed02f2a2e08679b1b4.svg";
export { ForwardRef as ReactComponent };